export default __webpack_public_path__ + "static/media/instagram.fc4a23c8.svg";